// extracted by mini-css-extract-plugin
export default {"main":"styles_main__EP27x","container":"styles_container__T8boN","form":"styles_form__0bfqh","w100":"styles_w100__HFLhE","w50":"styles_w50__DhJKN","send":"styles_send__OIlQv"};